// extracted by mini-css-extract-plugin
module.exports = {"Checkout":"Styles_Checkout__3t_xm","Card":"Styles_Card__3brKa"};